import { useDispatch, shallowEqual } from "react-redux";
import { useMemo, useEffect } from "react";
import { checkAuth, loadLanding } from "../store/actions";
import theme from "../styles/theme";
import { useHistory } from "react-router";
import { useShallowEqualSelector } from "../store";
import { getCurrentTenantDomain } from "../utils/tenant";

export const useAppStateConfig = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const {
    themeConfiguration,
    userSelectedThemeName,
    loading,
    landing,
    siteName,
    favicon,
    invalidDomain,
  } = useShallowEqualSelector(
    (state) => ({
      themeConfiguration: state.layout.theme,
      userSelectedThemeName: state.layout.userSelectedThemeName,
      loading: state.layout.loading,
      landing: state.layout.landing,
      siteName: state.layout.siteName,
      favicon: state.layout.favicon,
      invalidDomain: state.layout.invalidDomain,
    }),
    shallowEqual
  );

  const effectiveThemeConfiguration = useMemo(
    () => ({
      ...themeConfiguration,
      ...(userSelectedThemeName && { name: userSelectedThemeName }),
    }),
    [themeConfiguration, userSelectedThemeName]
  );

  const th = useMemo(
    () => theme(effectiveThemeConfiguration),
    [effectiveThemeConfiguration]
  );
  const domain = getCurrentTenantDomain();

  useEffect(() => {
    if (domain) {
      dispatch(checkAuth(domain, history));
    } else {
      dispatch(loadLanding());
    }
  }, [dispatch, domain, history]);

  return {
    domain,
    landing,
    loading,
    siteName,
    favicon,
    theme: th,
    themeName: effectiveThemeConfiguration.name,
    invalidDomain,
  };
};
